import EnTextField from 'Components/inputs/EnTextFieldV2/EnTextFieldV2.vue';
import EnValidationErrorMessage from 'Components/feedback/EnValidationErrorMessage/EnValidationErrorMessage.vue';
import EnOverlaySpinner from 'Components/feedback/EnOverlaySpinner/EnOverlaySpinner';
import EnIcon from 'Components/icons/EnIcon.vue';
import { getUrlParams } from 'Js/utils/urlUtils';
import { required, validEmail, minLength, maxLength } from 'Js/validation/rules';
import EnButton from 'Components/base/EnButton/EnButton.vue';
import { EnButtonType } from 'Components/types/EnButtonType';
export default {
  __name: 'register',
  setup(__props, _ref) {
    let __expose = _ref.expose;
    __expose();
    const accountName = ref('');
    const guid = ref('');
    const email = ref('');
    const password = ref('');
    const confirmPassword = ref('');
    const returnUrl = ref('');
    const errors = ref([]);
    const loading = ref(true);
    const successRequest = ref(null);
    const form = ref();
    const showPassword = ref(false);
    const showConfirmPassword = ref(false);
    const emailRules = ref([required, validEmail]);
    const updateRail = inject('updateRail');
    const passwordRules = ref([required, val => minLength(val, 6), val => maxLength(val, 100)]);
    const confirmPasswordRules = ref([required, val => minLength(val, 6), val => maxLength(val, 100), val => val === password.value || t('Authentication.password.reset.passwordsDoNotMatch')]);
    const backToLoginUrl = computed(() => {
      return "/Account/Login?returnUrl=".concat(returnUrl.value);
    });
    const isInvalid = computed(() => {
      return !(form.value && form.value.isValid);
    });
    function togglePasswordVisibility() {
      showPassword.value = !showPassword.value;
    }
    function toggleConfirmPasswordVisibility() {
      showConfirmPassword.value = !showConfirmPassword.value;
    }
    async function tryRegister() {
      loading.value = true;
      const response = await fetch("/api/Manage/TryRegister", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          Email: email.value,
          Password: password.value,
          ConfirmPassword: confirmPassword.value,
          ReturnUrl: returnUrl.value
        })
      });
      if (response.ok) {
        const config = await response.json();
        errors.value = config.errors;
        //If there are no errors, then registration is successful. Just open Login page
        if (errors.value.length === 0) {
          window.location.href = returnUrl.value;
        }
        loading.value = false;
      }
    }
    onBeforeMount(async () => {
      const params = getUrlParams(window.location);
      returnUrl.value = params['returnurl'];
      const additionalParams = new URLSearchParams(returnUrl.value);
      accountName.value = additionalParams.get('a');
      guid.value = additionalParams.get('g');
      const response = await fetch("/api/Manage/GetRegisterInfo?returnUrl=".concat(encodeURIComponent(returnUrl.value)), {
        method: 'POST'
      });
      if (response.ok) {
        const config = await response.json();
        if (config.errors.length > 0) {
          // If some errors encountered, we cannot allow user to process registration
          window.location.href = backToLoginUrl.value;
        }
      }
      loading.value = false;
    });
    onMounted(async () => {
      const main = document.querySelector('main.main-v2');
      main.classList.add('login-page');
      updateRail === null || updateRail === void 0 || updateRail(true);
    });
    const __returned__ = {
      accountName,
      guid,
      email,
      password,
      confirmPassword,
      returnUrl,
      errors,
      loading,
      successRequest,
      form,
      showPassword,
      showConfirmPassword,
      emailRules,
      updateRail,
      passwordRules,
      confirmPasswordRules,
      backToLoginUrl,
      isInvalid,
      togglePasswordVisibility,
      toggleConfirmPasswordVisibility,
      tryRegister,
      EnTextField,
      EnValidationErrorMessage,
      get EnOverlaySpinner() {
        return EnOverlaySpinner;
      },
      EnIcon,
      get getUrlParams() {
        return getUrlParams;
      },
      get required() {
        return required;
      },
      get validEmail() {
        return validEmail;
      },
      get minLength() {
        return minLength;
      },
      get maxLength() {
        return maxLength;
      },
      EnButton,
      get EnButtonType() {
        return EnButtonType;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};